"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setContext = exports.initState = void 0;
const react_1 = require("react");
exports.initState = {
    imageSize: 1,
    handleImageSize: (imgsize) => { },
};
function setContext() {
    const [imageSize, setImageSize] = (0, react_1.useState)(1);
    const handleImageSize = (imgsize) => {
        if (imageSize > 0)
            setImageSize(Math.floor(imgsize));
    };
    return {
        imageSize,
        handleImageSize
    };
}
exports.setContext = setContext;
